export const BRANDS_TITLES = [
	"ETaxi programėlės analogo kūrimo kaina",
	"Wolt programėlės analogo kūrimo kaina",
	"Citybee programėlės analogo kūrimo kaina",
	"WhatsApp programėlės analogo kūrimo kaina",
	"Bolt programėlės analogo kūrimo kaina",
	"Foodout programėlės analogo kūrimo kaina",
	"Airbnb programėlės analogo kūrimo kaina",
	"Tinder programėlės analogo kūrimo kaina"
];
